export default __webpack_public_path__ + "static/media/Testbench.6c6e7b38.jpeg";